export function eventsSliderSingle() {
    const $window = $(window);
    const $slider = $(".single-events-slider");
    let sliderNav = "";
    let $current = "";
    let $total = "";


    $slider.each(function () {
        let $this = $(this);
        sliderNav = $this.next(".events-slider-nav");
        $current = sliderNav.find('.current');
        $total = sliderNav.find('.total');
        $this.slick({
            dots: true,
            arrows: true,
            appendArrows: sliderNav,
            appendDots: sliderNav,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            autoplaySpeed: 5000,
            fade: true,
            cssEase: 'ease',
        }).on('init reInit afterChange', function (event, slick, currentSlide) {
            let i = (currentSlide ? currentSlide : 0) + 1;
            $current.text(i);
            $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
        });
        $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
        $current.text("1");
    });
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let slider = $(entry.target);
            slider.addClass("with-progress-animation");
            if (entry.isIntersecting) {
                slider.slick("slickPlay");
                slider.addClass("animation-play");
            } else {
                slider.slick("slickPause");
                slider.removeClass("animation-play");
            }
        });
    });
    $slider.each(function () {
        observer.observe(this);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/eventsSliderSingle.js